import { ApiService, ApiServiceInterface } from "../../../../../core";
import { EngagementAnswerData, EngagementDataResponse, EngagementListPageController, ProductsStrings, RequestAnswerResponse, RequestAnswerResponseData, RequestResponse } from "../../core";

export class EngagementListPageControllerImpl implements EngagementListPageController {
    private api: ApiServiceInterface;
    constructor() {
        this.api = new ApiService(process.env.REACT_APP_API)
    }

    async onLoad(): Promise<EngagementDataResponse> {
        try {
            const response = await this.api.get(`/engagement-page`);
            return response;
        } catch (error) {
            if (error?.response?.status === 401) {
                throw ("401");
            } else {
                throw new Error("Method not implemented.");
            }
        }
    }

    async registerSale(engagementId: string, quantity: number): Promise<string> {
        try {
            const requestData = {};
            requestData['engagement_id'] = engagementId;
            requestData['status'] = 'SOLD';
            requestData['quantity'] = quantity;

            const response: RequestResponse = await this.api.put('/engagement', requestData);
            return response.response;
        } catch (error) {
            throw new Error("Method not implemented.");
        }
    }

    async requestProductData(engagementId: string): Promise<number> {
        try {
            const response: RequestResponse = await this.api.get(`/engagement-page-product/${engagementId}`);
            if (response.success) {
                return parseInt(response.response);
            } else {
                throw new Error(response.response);
            }
        } catch (error) {
            throw new Error(error);
        }
    }

    async answerEngagement(answerData: EngagementAnswerData): Promise<RequestAnswerResponseData> {
        try {
            if (answerData.chosen === null) {
                throw new Error(ProductsStrings["PTBR"].products.engagementFails.choseOption);
            }
            const formData = new FormData();
            formData.append("chosen", answerData.chosen);
            formData.append("quantity", answerData.quantity.toString());

            const response: RequestAnswerResponse = await this.api.post('/engagement-page-answer', formData);
            return response.response;
        } catch (error) {
            if (error?.response?.status === 401) {
                throw new Error(ProductsStrings["PTBR"].products.engagementFails.login);
            } else {
                throw new Error(error);
            }
        }
    }
}